import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ArrowLastIcon = createIcon(
  'ArrowLast',
  <path
    id="a"
    d="M6.2925,15.4625 L10.1725,11.5825 L6.2925,7.7025 C5.9025,7.3125 5.9025,6.6825 6.2925,6.2925 C6.6825,5.9025 7.3125,5.9025 7.7025,6.2925 L12.2925,10.8825 C12.6825,11.2725 12.6825,11.9025 12.2925,12.2925 L7.7025,16.8825 C7.3125,17.2725 6.6825,17.2725 6.2925,16.8825 C5.9125,16.4925 5.9025,15.8525 6.2925,15.4625 Z M15,6.93166667 L15,16.2483333 C15,16.76075 15.45,17.18 16,17.18 C16.55,17.18 17,16.76075 17,16.2483333 L17,6.93166667 C17,6.41925 16.55,6 16,6 C15.45,6 15,6.41925 15,6.93166667 Z"
  />
);

export default ArrowLastIcon;
